const envModule = angular.module('env', []);

const envService = require('./env.service');
envModule.factory('Env', envService);  

module.exports = envModule;
